<ng-container>
  <div class="attention-summary__loading" *ngIf="loading && !total">
    <po-loading-overlay></po-loading-overlay>
  </div>
  <p *ngIf="loadError" class="po-font-text-small">Não foi possível carregar a lista.</p>

  <ng-container *ngIf="!loadError && !loading && !total">
    <p class="po-font-text-small">Nenhum review com ação Alta ou arquivo rejeitado neste recorte.</p>
    <p *ngIf="undetailedLabel" class="po-font-text-small">{{ undetailedLabel }}</p>
  </ng-container>

  <div class="attention-summary" *ngIf="total">
    <div class="attention-summary__headline">
      <p class="po-font-display">{{ totalLabel }}</p>
      <small class="po-font-text-small">reviews pedem ação</small>
      <div class="attention-summary__tags">
        <po-tag *ngIf="withHigh" [p-value]="highLabel" p-type="danger" p-inverse="true"></po-tag>
        <po-tag *ngIf="withRejected" [p-value]="rejectedLabel" p-type="warning" p-inverse="true"></po-tag>
      </div>
      <p *ngIf="undetailedLabel" class="po-font-text-small attention-summary__note">{{ undetailedLabel }}</p>
    </div>

    <div class="attention-summary__recent">
      <span class="po-font-text-small-bold">Mais recentes</span>
      <ul>
        <li *ngFor="let review of recent">
          <button type="button" class="attention-summary__item" (click)="open(review)"
            [attr.aria-label]="'Abrir review ' + review.title">
            <span class="attention-summary__item-text">
              <span class="po-font-text-bold">{{ review.title }}</span>
              <span class="po-font-text-small">{{ review.subtitle }}</span>
            </span>
            <span class="attention-summary__item-tags">
              <po-tag *ngIf="review.high" [p-value]="review.high" p-type="danger" p-inverse="true"></po-tag>
              <po-tag *ngIf="review.verdict" [p-value]="review.verdict" [p-type]="review.verdictType"></po-tag>
              <span class="po-icon po-icon-arrow-right" aria-hidden="true"></span>
            </span>
          </button>
        </li>
      </ul>
    </div>
  </div>

  <div class="attention-summary__footer" *ngIf="total">
    <po-button p-kind="secondary" p-icon="po-icon po-icon-list" [p-label]="showAllLabel" (p-click)="expand()"></po-button>
  </div>
</ng-container>

<po-modal p-title="Reviews que pedem ação" p-size="xl" p-click-out="true" [p-primary-action]="closeAction"
  (p-close)="expanded = false">
  <app-review-stats-attention *ngIf="expanded" [filters]="filters"
    (reviewOpened)="onReviewOpened()"></app-review-stats-attention>
</po-modal>
